var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4965 3.50322C12.9082 -0.0850586 7.09102 -0.0850586 3.50273 3.50322C-0.0855469 7.0915 -0.0855469 12.9087 3.50273 16.497C7.09102 20.0853 12.9082 20.0853 16.4965 16.497C20.0848 12.9087 20.0848 7.0915 16.4965 3.50322ZM14.502 8.329C14.298 8.53291 14.0918 8.73916 13.8879 8.94307C12.9926 9.83838 12.0996 10.7313 11.2043 11.6267C10.6418 12.1868 10.0816 12.7493 9.52148 13.3095C9.16289 13.6681 8.55352 13.6681 8.19492 13.3095C8.08477 13.1993 7.97461 13.0892 7.8668 12.979C7.09102 12.2009 6.31523 11.4251 5.53945 10.647C5.16914 10.2767 5.19492 9.69541 5.53945 9.32041C5.88164 8.94775 6.51914 8.97353 6.86602 9.32041C6.97617 9.43057 7.08633 9.54072 7.19414 9.65088C7.74961 10.2063 8.30508 10.7642 8.8582 11.3196C9.73711 10.4407 10.6137 9.56416 11.4926 8.68525L13.1754 7.00244C13.5457 6.63213 14.127 6.65791 14.502 7.00244C14.8746 7.34697 14.8488 7.98213 14.502 8.329Z",
    fill: "#38CB89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCompleted);
export default __webpack_public_path__ + "static/media/check-completed.8d363d5f1d9dafcdfa01efa79ba254bf.svg";
export { ForwardRef as ReactComponent };